import { Flex, Group } from '@mantine/core';
import type { PolicyOut, PolicySeverity } from '@repo/api-codegen';
import { SELECTABLE_PROPERTY_OPTIONS } from '@repo/common/components/SelectableProperty/constants';
import SingleSelector from '@repo/common/components/SingleSelector/SingleSelector';
import { Text } from '@repo/foundations';
import { useCallback } from 'react';
import { useUpdatePolicy } from '../../../PoliciesPage/hooks';
import { INLINE_TEXT_HEIGHT, INLINE_TEXT_WIDTH } from './constants';

interface InlineSeverityProps {
	policy: PolicyOut;
	readOnly?: boolean;
}

export default function InlineSeverity({
	policy,
	readOnly = false,
}: InlineSeverityProps) {
	const { mutateAsync: updatePolicy } = useUpdatePolicy({});

	const handleUpdateSeverity = useCallback(
		(id: string) => (severity: string | boolean | string[]) => {
			updatePolicy({
				pathParams: { policyId: id },
				body: { severity: severity as PolicySeverity },
			});
		},
		[updatePolicy]
	);

	return (
		<Group spacing="xs" noWrap align="flex-start">
			<Text
				w={INLINE_TEXT_WIDTH}
				style={{ lineHeight: `${INLINE_TEXT_HEIGHT}px` }}
				size="sm"
				color="text/secondary/default"
			>
				Severity
			</Text>
			<Flex pl="2xs">
				<SingleSelector
					variant="tertiary"
					searchable
					readOnly={readOnly}
					property="severity"
					placeholder={`No severity`}
					options={SELECTABLE_PROPERTY_OPTIONS['severity']}
					onChange={(severity: PolicySeverity) => {
						handleUpdateSeverity(policy.id)(severity);
					}}
					isViewerUser={false}
					initialSelected={policy.severity ?? 'NONE'}
					iconType={'tabler'}
					hideOnEmpty
				/>
			</Flex>
		</Group>
	);
}
